import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"
import { get, post } from "helpers/api_helper"
import { PATNERS, COURIER, SHIPMENT } from "helpers/url_helper"
import Select from "react-select"
import { showSuccessAlert, showErrorAlert } from "helpers/alert_helper"
import Papa from "papaparse"

const AddShipment = () => {
  const [clients, setClients] = useState([])
  const [csvData, setCsvData] = useState([])
  const [isUploading, setIsUploading] = useState(false) // Add this state
  const [courierPatner, setCourierPatner] = useState([])
  const [uploadedData, setUploadedData] = useState([])
  const [uploadedDataCount, setUploadedDataCount] = useState(0)

  const [formData, setFormData] = useState({
    sender_id: null,
    receivername: "",
    receivername: "",
    receiverphone: "",
    receiveremail: "",
    receiveraddress: "",
    receiverpincode: "",
    receivercity: "",
    receiverstate: "",
    receivercountry: "",
    sendername: "",
    senderphone: "",
    senderemail: "",
    senderaddress: "",
    senderpincode: "",
    sendercity: "",
    senderstate: "",
    sendercountry: "",
    vs_tracking_number: "",
    shipping_patner: null,
    live_tracking_number: "",
    shipping_cost: 0,
    weight: 1,
    H: 0,
    W: 0,
    D: 0,
  })

  const [shipmentSummary, setShipmentSummary] = useState({
    price: 0,
    base_price: 0,
    extra_per_kg: 0,
    weight: 0,
    total_payable: 0,
  })

  const [shipmnetType, setShipmnetType] = useState(false)

  const [errors, setErrors] = useState({
    receivername: "",
    receiverphone: "",
    receiveraddress: "",
    receiverpincode: "",
    receivercity: "",
    receiverstate: "",
    receivercountry: "",
    sendername: "",
    senderphone: "",
    senderaddress: "",
    senderpincode: "",
    sendercity: "",
    senderstate: "",
    sendercountry: "",
    vs_tracking_number: "",
    weight: "",
  })

  // Add this function to handle CSV file upload
  const handleFileUpload = event => {
    const file = event.target.files[0]
    if (file) {
      Papa.parse(file, {
        complete: results => {
          const [headers, ...data] = results.data
          setCsvData(data)
        },
        header: false,
      })
    }
  }

  const updateData = async () => {
    if (csvData.length === 0) return

    try {
      setIsUploading(true)
      setUploadedDataCount(`Processing CSV data: 0/${csvData.length}`)
      const filteredData = csvData.filter(row => row.length > 1)
      const CHUNK_SIZE = 10
      const chunks = []

      // Split into chunks
      for (let i = 0; i < filteredData.length; i += CHUNK_SIZE) {
        chunks.push(filteredData.slice(i, i + CHUNK_SIZE))
      }

      const allResponses = []

      const tempCounts = {
        totalsfailed: 0,
        successCount: 0,
        failedRows: [],
      }

      let processedCount = 0
      for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i]

        processedCount += chunk.length

        setUploadedDataCount(
          `Processing CSV data: ${processedCount}/${csvData.length}`
        )
        try {
          const { success, data } = await post(
            `${SHIPMENT}/uploadshipment`,
            chunk
          )
          if (success) {
            allResponses.push(data) // merge data

            tempCounts.totalsfailed += data?.failedCount || 0
            tempCounts.successCount += data?.successCount || 0
            tempCounts.failedRows = [
              ...tempCounts.failedRows,
              ...data?.failedRows,
            ]

            setUploadedData(tempCounts)
          }
        } catch (err) {
          console.error(`Chunk ${i + 1} failed`, err)
        }
      }
    } catch (error) {
      showErrorAlert("Error uploading CSV data")
    } finally {
      setIsUploading(false)
    }
  }

  useEffect(() => {
    updateData()
  }, [csvData])

  const resetFormData = () => ({
    sender_id: null,
    sendername: "",
    senderphone: "",
    senderemail: "",
    senderaddress: "",
    sendercity: "",
    senderstate: "",
    sendercountry: "",
    senderpincode: "",
  })

  useEffect(() => {
    const fetchData = async () => {
      const [clientsResponse, courierResponse] = await Promise.all([
        get(`${PATNERS}/options`),
        get(`${COURIER}/options`),
      ])

      if (clientsResponse.success) setClients(clientsResponse.data)
      if (courierResponse.success) setCourierPatner(courierResponse.data)
    }

    fetchData()
  }, [])

  /**
   * * Handle customer change
   */
  const handleCustomerChange = selectedOption => {
    if (selectedOption) {
      const { name, phone, email, address, city, state, country, pincode } =
        selectedOption

      setFormData(prevData => ({
        ...prevData,
        sender_id: selectedOption,
        sendername: name,
        senderphone: phone,
        senderemail: email,
        senderaddress: address,
        sendercity: city,
        senderstate: state,
        sendercountry: country,
        senderpincode: pincode,
      }))
      setShipmnetType(true)
    } else {
      setShipmnetType(false)
      setFormData(resetFormData())
    }
  }

  /**
   * formData change
   */
  const handleFormDataChange = e => {
    const { name, value } = e.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }))
  }

  const fetchLocationByPincode = async (pincode, type) => {
    try {
      const { success, data } = await get(
        `locations/search-pincode?pincode=${pincode}`
      )
      if (success) {
        setFormData(prevData => ({
          ...prevData,
          [`${type}city`]: data?.city,
          [`${type}state`]: data?.state,
          [`${type}country`]: data?.country,
        }))
      }
    } catch (error) {
      console.error(`Error fetching ${type} location:`, error)
    }
  }

  useEffect(() => {
    if (formData?.receiverpincode) {
      fetchLocationByPincode(formData.receiverpincode, "receiver")
    }
  }, [formData?.receiverpincode])

  useEffect(() => {
    if (formData?.senderpincode) {
      fetchLocationByPincode(formData.senderpincode, "sender")
    }
  }, [formData?.senderpincode])

  const removeWordsFromString = str => {
    const wordsToRemove = ["receiver", "sender"]

    let result = str.toLowerCase()
    wordsToRemove.forEach(word => {
      result = result.replace(word.toLowerCase(), "")
    })
    return result.charAt(0).toUpperCase() + result.slice(1) // Capitalize result
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const requiredFields = [
      "receivername",
      "receiveraddress",
      "receivercity",
      "receiverstate",
      "receivercountry",
      "receiverphone",
      "receiverpincode",
      "sendername",
      "senderaddress",
      "sendercity",
      "senderstate",
      "sendercountry",
      "senderphone",
      "senderpincode",
      "vs_tracking_number",
      "weight",
    ]

    let newErrors = {}
    let hasError = false

    requiredFields.forEach(field => {
      const value = formData[field]

      // Default error for required text fields
      if (!value) {
        newErrors[field] = `${removeWordsFromString(field)} required.`
        hasError = true
        return
      }

      // Specific validations
      if (
        (field === "receiverphone" || field === "senderphone") &&
        !/^[0-9]{10}$/.test(value)
      ) {
        newErrors[field] = "Phone number must be 10 digits."
        hasError = true
      }

      if (
        (field === "receiverpincode" ||
          field === "senderpincode" ||
          field === "vs_tracking_number") &&
        !/^[0-9]{6,10}$/.test(value)
      ) {
        newErrors[field] = "Must be 6 to 10 digits."
        hasError = true
      }

      if (field === "weight" && !/^[0-9]{1,4}$/.test(value)) {
        newErrors[field] = "Weight must be a number (1-4 digits)."
        hasError = true
      }
    })

    setErrors(newErrors)

    if (!hasError) {
      const obj = {
        ...formData,
        sender_id: formData?.sender_id?.value,
        shipping_patner: formData?.shipping_patner?.value,
        shipping_cost: shipmentSummary?.total_payable,
        height: formData?.H,
        width: formData?.W,
        length: formData?.D,
        price: shipmentSummary?.price,
        special_price: shipmentSummary?.base_price,
        additional_per_kg_price: shipmentSummary?.extra_per_kg || 0,
      }

      delete obj.H
      delete obj.W
      delete obj.D

      const { success, data } = await post(`${SHIPMENT}`, obj)
      if (success) {
        showSuccessAlert("Shipment added successfully")
        setFormData({
          sender_id: null,
          receivername: "",
          receivername: "",
          receiverphone: "",
          receiveremail: "",
          receiveraddress: "",
          receiverpincode: "",
          receivercity: "",
          receiverstate: "",
          receivercountry: "",
          sendername: "",
          senderphone: "",
          senderemail: "",
          senderaddress: "",
          senderpincode: "",
          sendercity: "",
          senderstate: "",
          sendercountry: "",
          vs_tracking_number: "",
          shipping_patner: null,
          live_tracking_number: "",
          shipping_cost: 0,
          weight: 1,
          H: 0,
          W: 0,
          D: 0,
          price: 0,
          special_price: 0,
          additional_per_kg_price: 0,
        })
      } else {
        showErrorAlert(errors)
      }
    }
  }

  const handleShippingPatnerChange = async selectedOption => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        shipping_patner: null,
        shipping_cost: 0,
      })
    }

    const obj = {
      id: selectedOption?.value,
      pincode: formData?.receiverpincode,
    }

    const { success, data } = await post("masters/courier_rates/calc", obj)
    if (success) {
      let final_price = data?.patner?.base_price

      setFormData({
        ...formData,
        shipping_patner: selectedOption,
        shipping_cost: data?.is_special
          ? data?.patner?.special_price
          : data?.patner?.base_price,
      })

      // Calculate additional price for weight > 1kg
      if (formData?.weight > 1) {
        const extraWeight = formData.weight - 1
        const extraCharge = extraWeight * data?.patner?.additional_per_kg_price
        final_price += extraCharge
      }

      // Apply special price if applicable
      if (data?.is_special) {
        final_price = formData?.weight * data?.patner?.special_price
      }

      setShipmentSummary(p => ({
        ...p,
        price: data?.patner?.price,
        base_price: data?.is_special
          ? data?.patner?.special_price
          : data?.patner?.base_price,
        extra_per_kg: data?.is_special
          ? data?.patner?.special_price
          : data?.patner?.additional_per_kg_price,
        weight: formData?.weight,
        total_payable: final_price,
      }))
    }
  }

  useEffect(() => {
    setShipmentSummary(p => ({
      ...p,
      price: formData.shipping_cost,
      base_price: formData.shipping_cost,
      extra_per_kg: formData.shipping_cost,
      weight: formData?.weight,
      total_payable: formData?.weight * formData.shipping_cost,
    }))
  }, [formData?.shipping_cost])

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col md={9}>
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={handleFileUpload}
                    className="form-control"
                    disabled={isUploading}
                    ref={input => input && !isUploading && (input.value = "")}
                  />
                  <span>
                    Download upload format sheet{" "}
                    <a href="/express_fly.csv" download>
                      click here
                    </a>
                  </span>
                  {isUploading && (
                    <div className="text-center mt-2">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">{uploadedDataCount}</p>
                    </div>
                  )}

                  {Object.keys(uploadedData)?.length > 0 && (
                    <div className="mt-3">
                      <h3 className="text-danger">Failed Uploading</h3>
                      <table
                        className="table table-bordered"
                        style={{
                          display: "block",
                          height: "260px",
                          overflow: "auto",
                        }}
                      >
                        <thead>
                          <th>#</th>
                          <th>Error</th>
                          <th>Tracking Number</th>
                          <th>Live Tracking Number</th>
                          <th>Patner Phone</th>
                          <th>weight</th>
                        </thead>
                        <tbody>
                          {uploadedData?.failedRows.reverse()?.map((v, i) => (
                            <tr key={`UDFR_${i}`}>
                              <td>{uploadedData?.failedRows.length - 1 - i}</td>
                              <td>{v.error || v.message}</td>
                              <td>{v.row?.vs_tracking_number || v.row[0]}</td>
                              <td>{v.row?.live_tracking_number || v.row[2]}</td>
                              <td>{v.row?.senderphone || v.row[3]}</td>
                              <td>{v.row?.weight || v.row[7]}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <h5>Receiver Information</h5>
                  <Row className="mt-2">
                    <Col>
                      <label>Receiver Name</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver name"
                        name="receivername"
                        defaultValue={formData?.receivername}
                      />
                      <span className="text-danger">{errors.receivername}</span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={6}>
                      <label>Receiver Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver Phone"
                        name="receiverphone"
                        defaultValue={formData?.receiverphone}
                      />
                      <span className="text-danger">
                        {errors.receiverphone}
                      </span>
                    </Col>
                    <Col md={6}>
                      <label>Receiver Email</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver Email"
                        name="receiveremail"
                        defaultValue={formData?.receiveremail}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <label>Receiver Address</label>
                      <textarea
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver Address"
                        name="receiveraddress"
                        defaultValue={formData?.receiveraddress}
                      />
                      <span className="text-danger">
                        {errors.receiveraddress}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <label>Receiver Pincode</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver Pincode"
                        name="receiverpincode"
                        defaultValue={formData?.receiverpincode}
                      />
                      <span className="text-danger">
                        {errors.receiverpincode}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <label>Receiver City</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver City"
                        name="receivercity"
                        defaultValue={formData?.receivercity}
                      />
                      <span className="text-danger">{errors.receivercity}</span>
                    </Col>
                    <Col>
                      <label>Receiver State</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver State"
                        name="receiverstate"
                        defaultValue={formData?.receiverstate}
                      />
                      <span className="text-danger">
                        {errors.receiverstate}
                      </span>
                    </Col>
                    <Col>
                      <label>Receiver Country</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleFormDataChange}
                        placeholder="Receiver Country"
                        name="receivercountry"
                        defaultValue={formData?.receivercountry}
                      />
                      <span className="text-danger">
                        {errors.receivercountry}
                      </span>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card>
                <CardBody>
                  <h5>
                    Sender Information ( {shipmnetType ? "Account" : "COD"})
                  </h5>
                  <Row className="mt-2">
                    <Col>
                      <label>Customers</label>
                      <Select
                        value={formData?.sender_id}
                        onChange={handleCustomerChange}
                        options={clients}
                        isSearchable={true}
                        isClearable={true}
                        placeholder="Select a customer"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <label>Sender Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sender Name"
                        onChange={handleFormDataChange}
                        name="sendername"
                        defaultValue={formData?.sendername}
                      />
                      <span className="text-danger">{errors.sendername}</span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md={6}>
                      <label>Sender Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sender Phone"
                        onChange={handleFormDataChange}
                        name="senderphone"
                        defaultValue={formData?.senderphone}
                      />
                      <span className="text-danger">{errors.senderphone}</span>
                    </Col>
                    <Col md={6}>
                      <label>Sender Email</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sender Email"
                        onChange={handleFormDataChange}
                        name="senderemail"
                        defaultValue={formData?.senderemail}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <label>Sender Address</label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Sender Address"
                        onChange={handleFormDataChange}
                        name="senderaddress"
                        defaultValue={formData?.senderaddress}
                      />
                      <span className="text-danger">
                        {errors.senderaddress}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <label>Sender Pincode</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sender Pincode"
                        onChange={handleFormDataChange}
                        name="senderpincode"
                        defaultValue={formData?.senderpincode}
                      />
                      <span className="text-danger">
                        {errors.senderpincode}
                      </span>
                    </Col>
                    <Col>
                      <label>Sender City</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sender City"
                        onChange={handleFormDataChange}
                        name="sendercity"
                        defaultValue={formData?.sendercity}
                      />
                      <span className="text-danger">{errors.sendercity}</span>
                    </Col>
                    <Col>
                      <label>Sender State</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sender State"
                        onChange={handleFormDataChange}
                        name="senderstate"
                        defaultValue={formData?.senderstate}
                      />
                      <span className="text-danger">{errors.senderstate}</span>
                    </Col>
                    <Col>
                      <label>Sender Country</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sender Country"
                        onChange={handleFormDataChange}
                        name="sendercountry"
                        defaultValue={formData?.sendercountry}
                      />
                      <span className="text-danger">
                        {errors.sendercountry}
                      </span>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardBody className="text-right">
                  <button className="btn btn-danger">Cancel</button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ float: "right" }}
                  >
                    Save
                  </button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col md={3}>
          <Card>
            <CardBody>
              <Row className="mt-2">
                <Col md={12}>
                  <label>Company Tracking Number</label>
                  <input
                    className="form-control"
                    name="vs_tracking_number"
                    onChange={handleFormDataChange}
                    value={formData?.vs_tracking_number}
                    placeholder="Company Tracking Number"
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={4}>
                  <label>Weight</label>
                  <input
                    type="number"
                    onChange={handleFormDataChange}
                    className="form-control"
                    name="weight"
                    value={formData?.weight}
                    placeholder="Weight"
                  />
                </Col>
                <Col>
                  <label>H</label>
                  <input
                    type="number"
                    onChange={handleFormDataChange}
                    className="form-control"
                    name="H"
                    value={formData?.H}
                    placeholder="H"
                  />
                </Col>
                <Col>
                  <label>W</label>
                  <input
                    type="number"
                    onChange={handleFormDataChange}
                    className="form-control"
                    name="W"
                    value={formData?.W}
                    placeholder="W"
                  />
                </Col>
                <Col>
                  <label>D</label>
                  <input
                    type="number"
                    onChange={handleFormDataChange}
                    className="form-control"
                    name="D"
                    value={formData?.D}
                    placeholder="D"
                  />
                </Col>
              </Row>

              <Row className="mt-2">
                <label>Shipping Patner</label>
                <Col md={12}>
                  <Select
                    value={formData?.shipping_patner}
                    onChange={handleShippingPatnerChange}
                    options={courierPatner}
                    isSearchable={true}
                    isClearable={true}
                    placeholder="Select Shipping Patner"
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <label>Live tracking Number</label>
                <Col md={12}>
                  <input
                    className="form-control"
                    name="live_tracking_number"
                    onChange={handleFormDataChange}
                    placeholder="Live tracking number"
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <label>Shipping Cost</label>
                <Col md={12}>
                  <input
                    className="form-control"
                    value={formData?.shipping_cost}
                    onChange={handleFormDataChange}
                    name="shipping_cost"
                    placeholder="Shipping Cost"
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                <span>
                  <b>Shipment Summary </b>
                </span>
                <Col className="mt-2">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td>Base Price</td>
                        <th>{shipmentSummary?.base_price}</th>
                      </tr>
                      <tr>
                        <td>Extra Per Kg</td>
                        <th>{shipmentSummary?.extra_per_kg}</th>
                      </tr>
                      <tr>
                        <td>Weight</td>
                        <th>{shipmentSummary?.weight}</th>
                      </tr>
                      <tr>
                        <td>Total Payable</td>
                        <th>{shipmentSummary?.total_payable}</th>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </form>
  )
}

AddShipment.propTypes = {
  is_update: PropTypes.bool,
}

export default AddShipment
